import React, { useEffect } from 'react';
import { FaExchangeAlt, FaGlobe, FaFileInvoice, FaShieldAlt } from 'react-icons/fa';
import '../styles/global.css'; // Ensure this import is present for styles

function Services() {
  useEffect(() => {
    const sections = document.querySelectorAll('.service-section');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(section => observer.observe(section));
  }, []);

  return (
    <div className="container mx-auto px-4 py-16">
      <h2 className="text-4xl font-semibold mb-12 text-gray-900 text-center">Our Services</h2>

      {/* Service 1: US-India Cross-Border Tax Advisory */}
      <section className="service-section bg-gray-50 p-8 mb-8 rounded-lg shadow-sm flex flex-col items-start fade-in">
        <div className="flex items-center mb-4">
          <FaExchangeAlt className="text-accent text-2xl mr-2" />
          <h3 className="text-2xl font-bold text-gray-800">US-India Cross-Border Tax Advisory</h3>
        </div>
        <p className="text-lg text-gray-700 mb-4">
          Navigating cross-border taxation requires specialized knowledge and a deep understanding of both US and Indian tax regulations. Our team brings Big 4-level expertise to help businesses and individuals optimize their tax positions while ensuring full compliance on both sides.
        </p>
        <ul className="list-disc list-inside text-gray-600 space-y-2">
          <li className="hover:text-accent transition">Advisory on structuring inbound and outbound investments</li>
          <li className="hover:text-accent transition">Compliance with US and Indian tax treaties</li>
          <li className="hover:text-accent transition">Guidance on residency and repatriation matters</li>
          <li className="hover:text-accent transition">Tax optimization strategies for dual residency individuals</li>
        </ul>
      </section>

      {/* Service 2: International Tax Structuring */}
      <section className="service-section bg-white p-8 mb-8 rounded-lg shadow-sm flex flex-col items-start fade-in">
        <div className="flex items-center mb-4">
          <FaGlobe className="text-accent text-2xl mr-2" />
          <h3 className="text-2xl font-bold text-gray-800">International Tax Structuring</h3>
        </div>
        <p className="text-lg text-gray-700 mb-4">
          As businesses expand globally, effective tax structuring becomes essential to maximize profitability and minimize risk. With extensive experience in complex multinational tax matters, we design tax-efficient structures that align with your business goals.
        </p>
        <ul className="list-disc list-inside text-gray-600 space-y-2">
          <li className="hover:text-accent transition">Custom solutions for tax-efficient cross-border operations</li>
          <li className="hover:text-accent transition">Transfer pricing compliance and risk mitigation</li>
          <li className="hover:text-accent transition">Controlled foreign corporation (CFC) compliance</li>
          <li className="hover:text-accent transition">Permanent establishment (PE) analysis and management</li>
        </ul>
      </section>

      {/* Service 3: Compliance and Filing Services */}
      <section className="service-section bg-gray-50 p-8 mb-8 rounded-lg shadow-sm flex flex-col items-start fade-in">
        <div className="flex items-center mb-4">
          <FaFileInvoice className="text-accent text-2xl mr-2" />
          <h3 className="text-2xl font-bold text-gray-800">Compliance and Filing Services</h3>
        </div>
        <p className="text-lg text-gray-700 mb-4">
          Staying compliant in an ever-evolving regulatory landscape can be challenging. Our compliance and filing services are designed to relieve you of the complexities associated with tax filings, statutory compliance, and regulatory reporting.
        </p>
        <ul className="list-disc list-inside text-gray-600 space-y-2">
          <li className="hover:text-accent transition">Corporate and individual tax return preparation and filing</li>
          <li className="hover:text-accent transition">FBAR and FATCA reporting for US taxpayers</li>
          <li className="hover:text-accent transition">Sales tax, GST, and VAT compliance for cross-border transactions</li>
          <li className="hover:text-accent transition">Quarterly and annual tax review services</li>
        </ul>
      </section>

      {/* Service 4: Tax Audit Support */}
      <section className="service-section bg-white p-8 mb-8 rounded-lg shadow-sm flex flex-col items-start fade-in">
        <div className="flex items-center mb-4">
          <FaShieldAlt className="text-accent text-2xl mr-2" />
          <h3 className="text-2xl font-bold text-gray-800">Tax Audit Support</h3>
        </div>
        <p className="text-lg text-gray-700 mb-4">
          Facing a tax audit can be stressful and time-consuming. At CrossTax Advisors, we leverage Big 4-level expertise to guide you through every step of the audit process, minimizing disruptions to your business.
        </p>
        <ul className="list-disc list-inside text-gray-600 space-y-2">
          <li className="hover:text-accent transition">Pre-audit risk assessment and documentation review</li>
          <li className="hover:text-accent transition">Direct representation before tax authorities</li>
          <li className="hover:text-accent transition">Post-audit compliance and remediation support</li>
          <li className="hover:text-accent transition">Continuous audit readiness for future tax periods</li>
        </ul>
      </section>

      {/* Contact Us Button */}
      <div className="text-center mt-12">
        <button className="btn-primary px-8 py-3 bg-accent text-white font-semibold rounded-full hover:bg-blue-600 hover:scale-105 hover:shadow-lg transition transform duration-300">
          Contact Us for a Consultation
        </button>
      </div>
    </div>
  );
}

export default Services;
